import {
  FormFieldContainer,
  FormFieldContainerProps,
} from "./FormFieldContainer";
import { FormFieldControl, FormFieldControlProps } from "./FormFieldControl";

export type { FormFieldContainerProps, FormFieldControlProps };

export const FormField = {
  Control: FormFieldControl,
  Container: FormFieldContainer,
};
